<template>
  <div>
      <Card>
          <Tabs v-model="paramtype" @on-click="changeTab">
            <TabPane name="base" label="教师信息">
             <teacher-base ref="teacherBase"></teacher-base>
            </TabPane>
            <!--<TabPane name="course" label="排课信息">-->
              <!--<teacher-course ref="teacherCourse"></teacher-course>-->
            <!--</TabPane>-->
            <!--<TabPane name="class" label="课程信息">-->
            <!--<teacher-class ref="teacherClass"></teacher-class>-->
            <!--</TabPane>-->
          </Tabs>
      </Card>
  </div>
</template>
<script>
  import teacherBase from './teacher_base'
  // import teacherCourse from './teacher_course'
  // import teacherClass from './teacher_class'
  export default {
    name: 'teacher_Form',
    data() {
      return {
        paramtype: 'base',

      }
    },
    components:{
      teacherBase,
      // teacherCourse,
      // teacherClass
    },
    mounted(){
      this.changeTab()
    },
    methods: {
      changeTab(){
        switch (this.paramtype){
          case "base":
            if(this.$route.query.id) {
              this.$refs.teacherBase.baseForm.id = this.$route.query.id;
              this.$refs.teacherBase.init();
              this.$refs.teacherBase.getTeacherBase();
            }
            this.$refs.teacherBase.getTeacherCourse()
            break;
          // case"course":
          //   if(this.$route.query.id) {
          //     this.$refs.teacherCourse.id = this.$route.query.id;
          //     this.$refs.teacherCourse.getAllTeacherCourse()
          //   }
          //   break;
          // case"class":
          //   this.$refs.teacherClass.id=this.$route.query.id;
          //   this.$refs.teacherClass.getTclass()
          //   this.$refs.teacherClass.getTimeList()
          //   break;
          default:break;
        }
      }
    }
  }
</script>
